export default __webpack_public_path__ + "static/media/MonthlyReport.3a9ce83a.svg";